import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { getMedicalStatusClass, MD_STATUS, tabTypeObj } from "./Constant";
import { FiEdit3, FiEye, FiInfo, FiPlusCircle } from "react-icons/fi";

import moment from "moment";

import {
  MEDICAL_STATUS_VIEW,
  MEDICAL_REPORT_STATUS,
  capitalLabel,
  MEDICAL_STATUS,
  MEDICAL_TYPE,
  MEDICAL_TYPE_OPTION,
  employeeFormLabel,
  medicalDueFilterFields,
  validateMedicalRowFilter,
} from "./Constant";

import {
  allMedicalAssignersCount,
  createMedical,
  getMedicalList,
} from "app/_services/ehs/MedicalService";

import { TRAINEE_TYPE_OPTION } from "../TrainingManagement/CONSTANTS";
import { useContractorPerson, useEmployee } from "app/_helpers/hooks";
import { Validation } from "app/_helpers/validation/Validation";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { isUserMedicalOfficer, isUserMM } from "../IncidentManagement/Helper";

import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";

import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import CustomTab from "app/Components/UI/Tab/CustomTab";
import AddToBatchModalMedical from "./Component/AddToBatchModalMedical";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import MedicalDueFilters from "./Component/MedicalDueFilters";
import { ACTIVE_MODULE, moduleType } from "app/_constants/constant";
import { getEmployee } from "app/_services/UserManagement/EmployeeService";
import { getAllContractorPerson } from "app/_services/UserManagement/ContractorPersonService";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import DeleteRecordIcon from "app/Components/DeleteRecordIcon/DeleteRecordIcon";

// const initialFilter = { medicalStatus: "all", medicalResult: "all" };

function MedicalExamDue() {
  //get status state
  // const filterStatus = useSelector((state) => state.filterReducerTraining);

  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 2);
  const [initialTableList, setInitialTableList] = useState([]);
  const [tableVFLList, setTableVFLList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [contractorStaffList, setContractorStaffList] = useState([]);
  const [tabCount, setTabCount] = useState({});
  const [loading, setLoading] = useState(true);

  // const [filter, setFilter] = useState(
  //   !filterStatus?.medicalFilter
  //     ? { ...initialFilter }
  //     : { ...filterStatus?.medicalFilter }
  // );
  const [showModal, setShowModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});

  const countData = useCallback(async () => {
    allMedicalAssignersCount().then((response) => {
      setTabCount(response?.data || {});
    });
  }, []);

  useEffect(() => {
    countData();
  }, [countData]);

  // useEffect(() => {
  //   getEmployee().then((response) => {
  //     setEmployeeList(response?.data?.employees || []);
  //   });

  //   getAllContractorPerson().then((response) => {
  //     setContractorStaffList(response?.data || []);
  //   });
  // }, []);

  const onReset = () => setFilterForm({ formA: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "medicalAssigneeTypeView") {
        prev.assigneeName = "";
        prev.assigneeID = "";
      }
      return { ...prev, [name]: value };
    });
  };

  // const dispatchFunction = useDispatch();

  //
  const initialData = useCallback(async () => {
    // getMedicalList(tabTypeObj[tab]).then((response) => {
    //   if (!response?.data) return;
    //   setInitialTableList(
    //     Array.isArray(response?.data)
    //       ? response?.data
    //           // ?.filter(
    //           //   (d) =>
    //           //     d.medicalStatus === MEDICAL_STATUS.due ||
    //           //     d.medicalStatus === MEDICAL_STATUS.overDue
    //           // )
    //           ?.map((d, index) => {
    //             // let objData = {};
    //             // if (d?.medicalAssigneeType === "employee") {
    //             //   objData = employeeList?.find((obj) => obj?.id === d?.medicalAssigneeId);
    //             // } else if (d?.medicalAssigneeType === "contractorPerson") {
    //             //   objData = contractorStaffList?.find(
    //             //     (obj) => obj?.id === d?.medicalAssigneeId
    //             //   );
    //             // }
    //             return {
    //               ...d,
    //               locationName: d?.ehsSite ? d?.ehsSite?.name : "",
    //               sid: index + 1,
    //               // assigneeID: objData ? objData?.srNo || objData?.employeeId : "",
    //               // assigneeName: objData
    //               //   ? `${objData?.firstName} ${objData?.lastName}`
    //               //   : "",
    //               // assigneeDesignation: objData
    //               //   ? objData?.srNo || objData?.employeeId
    //               //   : "",
    //               // formA: objData
    //               //   ? objData?.contractorFormA?.serialNumberOmc ||
    //               //     objData?.employeeFormA?.serialNumberOmc
    //               //   : "",
    //             };
    //           })
    //       : []
    //   );
    // });
    setLoading(true);
    const response = await getMedicalList(tabTypeObj[tab]);
    if (!response?.data) {
      setLoading(false);
      return;
    }
    setInitialTableList(
      Array.isArray(response?.data)
        ? response?.data?.map((d, index) => {
            return {
              ...d,
              locationName: d?.ehsSite ? d?.ehsSite?.name : "",
              sid: index + 1,
            };
          })
        : []
    );

    setLoading(false);
  }, [tab]);

  const manageMedicalTabs = useMemo(
    () => [
      {
        key: 2,
        label: `IME Medical  (${
          //initialTableList.filter((d) => d.medicalTestType === MEDICAL_TYPE.ime).length
          tabCount?.ime || 0
        })`,
      },
      {
        key: 3,
        label: `PME Medical (${
          //initialTableList.filter((d) => d.medicalTestType === MEDICAL_TYPE.pme).length
          tabCount?.pme || 0
        })`,
      },
      {
        key: 4,
        label: `SME Medical (${
          //initialTableList.filter((d) => d.medicalTestType === MEDICAL_TYPE.sme).length
          tabCount?.sme || 0
        })`,
      },
    ],
    [tabCount?.ime, tabCount?.pme, tabCount?.sme]
  );

  // const onChangeFilter = ({ target: { name, value }, index }) => {
  //   setFilter((prev) => ({ ...prev, [name]: value }));
  // };

  // useEffect(() => {
  //   // set status in redux store
  //   dispatchFunction(filterActionAdd({ medicalFilter: filter }));
  // }, [filter]);

  const tableToolbarView = () => (
    <CustomTooltip tooltip={"Assign Training"}>
      <span
        className="icons btn-icon font-20 text-cyanBlue"
        // to={`/health-safety-and-environment/medical/add`}
        onClick={() => setShowModal(true)}
      >
        <FiPlusCircle />
      </span>
    </CustomTooltip>
  );

  const onChangeTab = (tabValue) => {
    if (tab === tabValue) return;
    setTab(tabValue);
    setTableVFLList([]);
    setInitialTableList([]);
    // setFilter({ ...initialFilter });
    // setSelectedTraining([]);
  };
  console.log("qwerFilterForm", filterForm);
  // ************Use Memo ***************
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      // {
      //   dataField: "medicalTestTypeView",
      //   text: "Medical Type",
      //   sort: true,
      // },
      {
        dataField: "medicalAssigneeTypeView",
        text: "Emp Type",
        sort: true,
      },
      {
        dataField: "assigneeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "assigneeName",
        text: "Name",
        sort: true,
        formatter: (idx, name) => {
          return <div>{capitalizeName(name.assigneeName)}</div>;
        },
      },
      // {
      //   dataField: "categoryName",
      //   text: "Skill Category",
      //   sort: true,
      // },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      {
        dataField: "dueDateView",
        text: "Due Date",
        sort: true,
        formatter: (date) => moment(date).format("DD-MM-YYYY"),
      },
      {
        dataField: "medicalStatusView",
        text: "Status",
        sort: true,
        formatter: (val) => capitalLabel(val),
        formatter: (status, row) => {
          return <div className={getMedicalStatusClass(status)}>{status}</div>;
        },
      },
      // {
      //   dataField: "medicalResult",
      //   text: "Report Status",
      //   sort: true,
      //   formatter: (val) => capitalLabel(val),
      // },
      // {
      //   dataField: "Certificate",
      //   text: "Certificate",
      //   sort: true,
      //   formatter: (id, row) => {
      //     return (
      //       <div className="actionIconsGroup">
      //         {row?.medicalStatus === MEDICAL_STATUS.approved &&
      //           row?.medicalResult === MEDICAL_REPORT_STATUS.fit &&
      //           isUserMedicalOfficer() && (
      //             <CustomTooltip tooltip={"Certificate"}>
      //               <a
      //                 href={
      //                   (row?.medicalTestType.toLowerCase() === "sme"
      //                     ? "/health-safety-and-environment/medical-management/sme-certificate/"
      //                     : "/health-safety-and-environment/medical/certificate/") +
      //                   row?.id
      //                 }
      //                 target="_blank"
      //                 rel="noopener noreferrer"
      //                 className="icons text-cyanBlue"
      //               >
      //                 <FiInfo style={{ color: "rgb(21 239 21)" }} />
      //               </a>
      //             </CustomTooltip>
      //           )}
      //       </div>
      //     );
      //   },
      // },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          let editFlag = false;

          // if (row?.medicalStatus === MEDICAL_STATUS.approved) editFlag = false;

          if (row?.medicalStatus) {
            if (
              (row?.medicalStatus === MEDICAL_STATUS.due ||
                row?.medicalStatus === MEDICAL_STATUS.overDue ||
                row?.medicalStatus === MEDICAL_STATUS.inProgress) &&
              isUserMedicalOfficer()
            )
              editFlag = true;

            if (row?.medicalStatus === MEDICAL_STATUS.mmReview && isUserMM())
              editFlag = true;
          }

          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={"/health-safety-and-environment/medical/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>

              {editFlag && (
                <CustomTooltip tooltip={"Edit"}>
                  <Link
                    to={"/health-safety-and-environment/medical/edit/" + row.id}
                    className="icons text-cyanBlue"
                  >
                    <FiEdit3 />
                  </Link>
                </CustomTooltip>
              )}
              <DeleteRecordIcon
                id={row.id}
                moduleType={moduleType.ehsMedicalAssigners}
                setLoading={setLoading}
                reloadData={initialData}
              />
            </div>
          );
        },
      },
    ];

    if (tab === 4)
      column.splice(3, 0, {
        dataField: "smeCategoryView",
        text: "SME Category",
        sort: true,
      });

    return column;
  }, [tab]);

  // ************Use Effect ***************
  useEffect(() => {
    if (+tab > 0) CommmonService.updateQueryParam("tab", tab);
  }, [tab]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  useEffect(() => {
    setTableVFLList(
      initialTableList
        // .filter((d) => {
        //   // let flag =
        //   //   (filter.medicalStatus === "all" || filter.medicalStatus === d?.medicalStatus) &&
        //   //   (filter.medicalResult === "all" || filter.medicalResult === d?.medicalResult);
        //   let flag = true;
        //   // switch (tab) {
        //   //   case 2:
        //   //     if (d.medicalTestType !== MEDICAL_TYPE.ime) return false;
        //   //     break;

        //   //   case 3:
        //   //     if (d.medicalTestType !== MEDICAL_TYPE.pme) return false;
        //   //     break;

        //   //   case 4:
        //   //     if (d.medicalTestType !== MEDICAL_TYPE.sme) return false;
        //   //     break;

        //   //   default:
        //   //     break;
        //   // }

        //   return flag;
        // })
        ?.filter?.((obj) => {
          return validateMedicalRowFilter(obj, filterForm);
        })
        ?.map((d, i) => ({ ...d, sid: i + 1 }))
    );
  }, [filterForm, initialTableList, tab]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <MedicalDueFilters
        fields={medicalDueFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Personnel Health Management",
            path: "/health-safety-and-environment/medical",
          },
          { name: "Medical Exam Due" },
        ]}
        module={ACTIVE_MODULE.personnelHealthManagement}
      />
      <div className="healthSafetyEnvironmentWrapper">
        <CustomTab tabs={manageMedicalTabs} activeTabKey={tab} setTab={onChangeTab} />

        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title cardCustomHeader">
              <h3 class="text-capitalize mb-1">Medical Exam Due</h3>
              <FilterBtn setShowFilter={setShowFilter} />

              <BackBtn url={"/health-safety-and-environment/medical"} />
            </div>
            {!loading ? (
              <SearchBootstrapTable
                searchKey={"medicalExamDueDesktopSearch"}
                data={tableVFLList}
                columns={sortableColumn}
                tableToolbarView={tableToolbarView}
                tableBeforeSearch={tableToolbarBeforeView}
                tableKey="medicalExamDue"
              />
            ) : (
              <NetZeroLoader />
            )}
          </div>
        </div>

        <AddToBatchModalMedical show={showModal} onHide={setShowModal} />
      </div>
    </>
  );
}

export default MedicalExamDue;
